export default __webpack_public_path__ + "static/media/wine-bar.95e18a56.jpg";